import React from 'react';

interface TermsOfServiceDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * 이용약관 다이얼로그
 */
const TermsOfServiceDialog: React.FC<TermsOfServiceDialogProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '20px',
        boxSizing: 'border-box'
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          maxWidth: '640px',
          width: '100%',
          maxHeight: '80vh',
          overflow: 'auto',
          padding: '24px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
          paddingBottom: '16px',
          borderBottom: '1px solid var(--Color-line-normal, #F0F0F0)'
        }}>
          <h2 style={{
            margin: 0,
            fontSize: '20px',
            fontWeight: 600,
            color: 'var(--Color-text-strong, #0D0D0D)',
            fontFamily: 'Pretendard, sans-serif'
          }}>
            이용약관
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: 'var(--Color-text-normal, #161616)',
              padding: '0 8px'
            }}
            aria-label="닫기"
          >
            ×
          </button>
        </div>

        <div style={{
          fontSize: '14px',
          lineHeight: '1.6',
          color: 'var(--Color-text-normal, #161616)',
          fontFamily: 'Pretendard, sans-serif'
        }}>
          <p style={{ marginBottom: '16px' }}>
            Maru(이하 "서비스") 이용약관에 오신 것을 환영합니다. 본 약관은 서비스 이용에 관한 조건 및 절차, 당사와 이용자의 권리, 의무, 책임사항을 규정합니다.
          </p>

          <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>제1조 (목적)</h3>
          <p style={{ marginBottom: '16px' }}>
            본 약관은 Maru 서비스의 이용조건 및 절차, 당사와 이용자의 권리·의무·책임사항과 기타 필요한 사항을 규정함을 목적으로 합니다.
          </p>

          <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>제2조 (서비스의 제공)</h3>
          <p style={{ marginBottom: '16px' }}>
            서비스는 학급·교과 운영, 출석·성적 관리, 포인트 및 역할 부여 등 교육 활동 지원을 위한 온라인 서비스를 제공합니다.
          </p>

          <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>제3조 (이용자의 의무)</h3>
          <p style={{ marginBottom: '16px' }}>
            이용자는 서비스를 이용할 때 다음 각 호의 행위를 하여서는 안 됩니다. 타인의 정보 도용, 서비스 운영 방해, 법령 또는 공서양속에 위반되는 행위 등
          </p>

          <p style={{ marginBottom: '0', fontSize: '12px', color: 'var(--Color-text-assistive, #989898)' }}>
            시행일자: 2026년 1월 1일
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServiceDialog;
